<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>项目名称</th>
						<td colspan="3">{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>工程名称</th>
						<td colspan="3">{{ constructionPermitDetail.engineeringName }}</td>
					</tr>
					<tr>
						<th>建设地址</th>
						<td colspan="3">{{ constructionPermitDetail.designAddress }}</td>
					</tr>
					<tr>
						<th>所在地市</th>
						<td>{{ constructionPermitDetail.cityName }}</td>
						<th>所在区县</th>
						<td>{{ constructionPermitDetail.countyName }}</td>
					</tr>
					<tr>
						<th>统一地址描述</th>
						<td>{{ constructionPermitDetail.addressDescription }}</td>
						<th>统一地址识别码</th>
						<td>{{ constructionPermitDetail.addressHeadCode }}</td>
					</tr>
					<tr>
						<th>施工许可证编号</th>
						<td>{{ constructionPermitDetail.constructionPermitCode }}</td>
						<th>施工许可环节编码</th>
						<td>{{ constructionPermitDetail.constructionPermitLinkCode }}</td>
					</tr>
					<tr>
						<th>合同金额(万元)</th>
						<td>{{ constructionPermitDetail.contractMoney }}</td>
						<th>合同工期(天)</th>
						<td>{{ constructionPermitDetail.contractWorkPeriod }}</td>
					</tr>
					<tr>
						<th>施工图审查合格证书编号</th>
						<td>{{ constructionPermitDetail.reviewCerCode }}</td>
						<th>施工面积(平方米)</th>
						<td>{{ constructionPermitDetail.constructionArea }}</td>
					</tr>
					<tr>
						<th>长度(米)</th>
						<td>{{ constructionPermitDetail.length }}</td>
						<th>跨度(米)</th>
						<td>{{ constructionPermitDetail.span }}</td>
					</tr>
					<tr>
						<th>建设规模</th>
						<td colspan="3">{{ constructionPermitDetail.designScale }}</td>
					</tr>
					<tr>
						<th>建设单位名称</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>建设单位唯一代码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>勘察单位名称</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>勘察单位唯一代码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>项目负责人姓名</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>项目负责人证件号码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>设计单位名称</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>设计单位唯一代码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>项目负责人姓名</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>项目负责人证件号码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>施工单位名称</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>施工单位唯一代码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>项目负责人姓名</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>项目负责人证件号码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>监理单位名称</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>监理单位唯一代码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>项目负责人姓名</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>项目负责人证件号码</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
					</tr>
					<tr>
						<th>记录登记时间</th>
						<td>{{ constructionPermitDetail.projectName }}</td>
						<th>发证日期</th>
						<td>{{ constructionPermitDetail.makeTime }}</td>
					</tr>
					<tr>
						<th>备注</th>
						<td colspan="3">{{ constructionPermitDetail.remark }}</td>
					</tr>
				</table>
			</div>

			<!-- 批量数据切换 -->
			<div class="tab-pane-container">
				<!-- tab头部区域--start -->
				<div class="tab-pane-header">
					<!-- tab选项 -->
					<div class="tab-pane-navs">
						<div
							v-for="(item, index) in detailTabs"
							:key="index"
							:class="['tab-pane-item', { active: activeTabIndex === index }]"
							@click="activeTabIndex = index"
						>
							{{ item.name }}
						</div>
					</div>
				</div>
				<!-- tab头部区域--end -->
				<!-- tab内容区域--start -->
				<div class="tab-pane-content">
					<!-- 勘察 -->
					<div :class="['tab-pane-content__item', { active: activeTabIndex === 0 }]">
						<data-table
							:table-data="constructionPermitDetail.permitPersonList2"
							:column="personColumns"
							:page-hide="true"
							:border="false"
						></data-table>
					</div>
					<!-- 设计 -->
					<div :class="['tab-pane-content__item', { active: activeTabIndex === 1 }]">
						<data-table
							:table-data="constructionPermitDetail.permitPersonList3"
							:column="personColumns"
							:page-hide="true"
							:border="false"
						></data-table>
					</div>
					<!-- 施工 -->
					<div :class="['tab-pane-content__item', { active: activeTabIndex === 2 }]">
						<data-table
							:table-data="constructionPermitDetail.permitPersonList3"
							:column="personColumns"
							:page-hide="true"
							:border="false"
						></data-table>
					</div>
					<!-- 监理 -->
					<div :class="['tab-pane-content__item', { active: activeTabIndex === 3 }]">
						<data-table
							:table-data="constructionPermitDetail.permitPersonList4"
							:column="personColumns"
							:page-hide="true"
							:border="false"
						></data-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { transObject } from '@/utils/index'
	import { getConstructionPermitDetail } from '@/api/qualificationQuery/project'

	// 施工许可详情
	export default {
		name: 'ConstructionPermitDetails',
		components: {
			DataTable,
			NonbindVip,
			NonbindSvip
		},
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				detailTabs: [{ name: '勘察' }, { name: '设计' }, { name: '施工' }, { name: '监理' }],
				activeTabIndex: 0,

				// 数据加载状态
				loading: false,
				isVip: false,
				isSVip: false,
				// 施工许可详情对象
				constructionPermitDetail: {
					// 项目名称
					projectName: '',
					// 工程名称
					engineeringName: '',
					// 建设地址
					designAddress: '',
					// 所在地市
					cityCode: '',
					cityName: '',
					// 所在区县
					countyCode: '',
					countyName: '',
					// 统一地址描述
					addressDescription: '',
					// 统一地址识别码
					addressHeadCode: '',
					// 施工许可证编号
					constructionPermitCode: '',
					// 施工许可环节编码
					constructionPermitLinkCode: '',
					// 合同金额
					contractMoney: '',
					// 合同周期
					contractWorkPeriod: '',
					// 施工图审查合格证书编号
					reviewCerCode: '',
					// 施工面积
					constructionArea: '',
					// 长度
					length: '',
					// 跨度
					span: '',
					// 建设规模
					designScale: '',
					// 发证日期
					makeTime: '',
					// 备注
					remark: '',
					permitPersonList1: [],
					permitPersonList2: [],
					permitPersonList3: [],
					permitPersonList4: []
				},

				personColumns: [
					{ label: '姓名', prop: 'name', align: 'center' },
					{ label: '性别', prop: 'name', align: 'center' },
					{ label: '证件类型', prop: 'name', align: 'center' },
					{ label: '岗位', prop: 'name', align: 'center' },
					{ label: '证件号码', prop: 'idCard', align: 'center' },
					{ label: '参建时间', prop: 'name', align: 'center' }
				],
				message: ''
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryConstructionPermitDetail()
		},
		methods: {
			// 查询合同登记详情
			handleQueryConstructionPermitDetail() {
				this.loading = true
				const params = {
					constructionPermitId: this.id
				}

				getConstructionPermitDetail(params)
					.then(response => {
						const { data, code, message } = response

						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								// 将目标数据转为我指定的属性对象
								transObject(data, this.constructionPermitDetail)
							}
						}
						this.loading = false
					})
					.catch(error => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
